<template>
  <div class="min-h-screen bg-black text-white py-8 px-4 md:px-8 md:mt-16">
    <!-- <div
      class="w-full flex justify-start -mt-3 cursor-pointer"
      @click="router.back()"
    >
      <PhArrowLeft class="w-7 h-7 text-gray-500 mb-2" />
    </div> -->

    <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- Coluna da esquerda (informacoes do evento) -->
      <div class="md:col-span-2">
        <div class="w-full flex justify-center">
          <img
            :src="
              event?.event?.banner ? fileUrl + event?.event?.banner : banner
            "
            :alt="event?.event?.title"
            class="w-full rounded-lg object-cover max-h-[300px] max-w-[400px]"
          />
        </div>

        <div class="w-full flex justify-center tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <h1 class="text-3xl font-bold mt-6 tracking-wide">
              {{ event?.event?.title }}
            </h1>
          </div>
        </div>

        <div class="w-full flex justify-center font-inter tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <div class="flex items-center gap-2 mt-4 text-gray-300">
              <PhCalendar class="w-5 h-5" />
              <span>{{ formatDate(event?.event?.starts_at) }}</span>
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhClock class="w-5 h-5" />
              <span>{{ formatHour(event?.event?.starts_at) }}</span>
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhMapPinArea class="w-5 h-5" />
              <span>{{ event?.event?.location ?? "não informado" }}</span>
            </div>

            <div class="mt-8 font-inter">
              <h2 class="text-xl font-semibold mb-2">Detalhes do evento</h2>
              <p class="text-gray-400">
                {{ event?.event?.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna da direita (checkout/resumo) -->
      <div class="relative" :key="event">
        <div class="bg-zinc-900 rounded-lg p-6 sticky top-8">
          <!-- total -->
          <div class="flex justify-between items-center mb-4" v-if="acquired == false">
            <section
              class="flex flex-col gap-y-4 w-full justify-start text-start"
              v-if="event?.event?.price"
            >
              <!-- total -->
              <div class="flex justify-between">
                <span class="text-lg font-semibold tracking-wide uppercase">
                  {{
                    (sponsorshipPage && amount?.label) || porcent?.label
                      ? "Valor original"
                      : "Total"
                  }}
                </span>
                <span class="text-2xl font-bold text-green-400 tracking-wide">
                  R$ {{ event?.event?.price }}
                </span>
              </div>

              <!-- porcent -->
              <div v-if="event?.porcent">
                <div class="flex justify-between" v-if="event?.porcent">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Valor promocional
                  </span>
                  <span class="text-2xl font-bold text-green-400 tracking-wide">
                    <p>
                      R$ {{ porcent.final }}
                    </p>
                    <p class="text-red-600 text-sm w-full text-right">
                      {{ porcent.label }}
                    </p>
                  </span>
                </div>

                <div
                  class="flex items-center mt-2 mb-2 text-gray-400 text-sm lowercase"
                >
                  <div class="flex-1 h-px bg-gray-600"></div>
                  <div class="flex-1 h-px bg-gray-600"></div>
                </div>

                <div class="flex justify-between">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Total
                  </span>
                  <span class="text-2xl font-bold text-green-400 tracking-wide">
                    R$ {{ porcent.final }}
                  </span>
                </div>
              </div>

              <!-- amount -->
              <div v-else-if="event?.amount">
                <div class="flex justify-between">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Valor promocional <br />
                    <small class="text-gray-600">
                      {{ amount.label }}
                    </small>
                  </span>
                  <span class="text-2xl font-bold text-green-400 tracking-wide">
                    R$ {{ amount.final }}
                  </span>
                </div>

                <div
                  class="flex items-center mt-2 mb-2 text-gray-400 text-sm lowercase"
                >
                  <div class="flex-1 h-px bg-gray-600"></div>
                  <div class="flex-1 h-px bg-gray-600"></div>
                </div>

                <div class="flex justify-between">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Total
                  </span>
                  <span class="text-2xl font-bold text-green-400 tracking-wide">
                    R$ {{ amount.final }}
                  </span>
                </div>

              </div>
            </section>
          </div>

          <div :key="acquired">
            <button
              v-if="sponsorshipPage"
              class="w-full bg-red-600 hover:bg-red-700 transition rounded-lg text-white py-3 font-bold text-center uppercase text-2xl md:text-xl"
              @click="copyClipboardLink()"
            >
              Copiar link de patrocínio
            </button>
  
            <button
              v-else-if="canAccess"
              class="w-full bg-red-600 hover:bg-red-700 transition rounded-lg text-white py-3 font-bold text-center uppercase text-2xl md:text-xl"
              @click="goToEvent()"
            >
              Assitir evento
            </button>
            
            <button
              v-else
              class="w-full bg-red-600 hover:bg-red-700 transition rounded-lg text-white py-3 font-bold text-center uppercase text-2xl md:text-xl"
              @click="goToCheckout()"
            >
              Comprar ingresso
            </button>
          </div>
        </div>

        <section v-if="sponsorshipPage">
          <div class="flex items-center mt-4 text-gray-400 text-sm lowercase">
            <div class="flex-1 h-px bg-gray-600"></div>
            <span class="mx-2"> Ou </span>
            <div class="flex-1 h-px bg-gray-600"></div>
          </div>

          <h2>Escanear QR Code</h2>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { showToast as toast } from '@/helpers/UseToasts'
import router from '@/router'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { formatDate, formatHour } from '@/utils/formaters'
import { PhCalendar, PhClock, PhMapPinArea } from '@phosphor-icons/vue'
import { initFlowbite } from 'flowbite'
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue'

import { useRoute } from 'vue-router'

const isPaid = ref(true)
const route = useRoute()
const banner = require('./../../../assets/logo/logo-rs-bg.png')
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'

const eventId = route.params.id
const event = ref({})
const sponsorshipPage = ref(false)
const fighter = route.query.fighter
const affiliate = route.query.affiliate
const couponId = computed(() => route.query.couponId)

const amount = computed(() =>
  applyDiscountAmount(event.value?.event?.price, event?.value)
)
const porcent = computed(() =>
  applyDiscountPorcent(event.value?.event?.price, event?.value)
)

async function getItem () {
  dataShared.dispatch('activeLoading')
  await SharedService.getEventById(eventId)
    .then(res => {
      sponsorshipPage.value = false
      event.value.event = res.data
      dataShared.dispatch('desactiveLoading')
    })
    .catch((err) => {
      dataShared.dispatch('desactiveLoading')
      if (err?.response?.data?.error && err.response.data.status === 400) {
        router.push({ name: 'events' })
        return toast('Aviso', err.response.data.message, 'error')
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        router.push({ name: 'events' })
        return toast('Aviso', err.response.data.message, 'error')
      }

      if (err?.response?.data?.error && err.response.data.status === 429) {
        router.push({ name: 'auth' })
        return toast('Aviso', err.response.data.message, 'error')
      }
    })
}

async function validityCoupon () {
  dataShared.dispatch('activeLoading')

  await SharedService.validityCoupon(couponId.value)
    .then((res) => {
      sponsorshipPage.value = false
      event.value = res.data
      dataShared.dispatch('desactiveLoading')
    })
    .catch((err) => {
      if (err?.response?.data?.error && err.response.data.status === 400) {
        router.replace({ path: route.path, query: {} })
        getItem()
        return toast('Aviso', err.response.data.message, 'error')
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        router.replace({ path: route.path, query: {} })
        getItem()
        return toast('Aviso', err.response.data.message, 'error')
      }

      router.replace({ path: route.path, query: {} })
      getItem()
      return toast('Aviso', 'Algo deu errado com sua solicitação', 'error')
    })

  dataShared.dispatch('desactiveLoading')
}
async function getSponsorship () {
  dataShared.dispatch('activeLoading')
  await SharedService.setSponsorshipPage(fighter, affiliate)
    .then((res) => {
      sponsorshipPage.value = true
      event.value = res.data
      dataShared.dispatch('desactiveLoading')
    })
    .catch((err) => {
      dataShared.dispatch('desactiveLoading')
    })
}

function applyDiscountAmount (price, coupon = {}) {
  const originalPrice = parseFloat(price)

  let discount = 0
  let label = ''

  if (coupon.amount) {
    discount = parseFloat(coupon.amount)
    label = `R$ ${discount.toFixed(2).replace('.', ',')} de desconto`
  }

  const finalPrice = Math.max(0, originalPrice - discount)

  return {
    original: originalPrice.toFixed(2),
    discount: discount.toFixed(2),
    final: finalPrice.toFixed(2),
    label
  }
}

function applyDiscountPorcent (price, coupon = {}) {
  const originalPrice = parseFloat(price)

  let discount = 0
  let label = ''

  if (coupon.porcent) {
    const porcent = parseFloat(coupon.porcent)
    discount = (originalPrice * porcent) / 100
    label = `${porcent}% OFF`
  }

  const finalPrice = Math.max(0, originalPrice - discount)

  return {
    original: originalPrice.toFixed(2),
    discount: discount.toFixed(2),
    final: finalPrice.toFixed(2),
    label
  }
}

function copyClipboardLink () {
  const link =
    process.env.VUE_APP_BASE_URL +
    `purchase/${eventId}/event?couponId=${affiliate}`

  console.log(link);

  if (!navigator.clipboard) {
    alert('Aviso, link não copiado')
    return
  }

  navigator.clipboard
    .writeText(link)
    .then(() => {
      toast('Aviso', 'Link copiado com sucesso', 'success')
    })
    .catch((err) => {
      console.error('Erro ao copiar o link: ', err)
      alert('Não foi possível copiar o link.')
    })
}

async function goToCheckout () {
  // verificar se o evento já esta comprado
  // isPaid.value
  //   ? dataShared.dispatch('setLiveActive', eventId)
  //   : ''
  dataShared.dispatch('activeLoading')

  await SharedService.initiate(eventId, couponId.value)
    .then((res) => {
      dataShared.dispatch('desactiveLoading')
      toast('Aviso', 'Redirecionando para o pagamento aguarde...', 'info')

      window.open(res.data.payment_link)
    })
    .catch((err) => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 401) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 429) {
        return toast(
          'Aviso',
          'Multiplas tentativas, tente novamente mais tarde',
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao realizar pagamento',
        'error'
      )
    })
}

// caso já tenha acesos ao evento
function goToEvent () {
  dataShared.dispatch('setEventToPurchase', event.value?.event?.id)
  dataShared.dispatch('setLiveActive', event.value?.event)
  router.push(`/live/${event.value?.event?.id}`)
}

const user = computed(() => dataShared.getters.getDataByUserLogged)
const acquired = computed(() => {
  return user.value?.purchases.some(p => p?.event_id === eventId)
})
const freeEvent = computed(() => event.value?.event?.price == null ? true : false)
const canAccess = computed(() => {
  return acquired.value || freeEvent.value
})

onBeforeMount(async () => {
  await dataShared.dispatch('fetchLoggedUser')
  
  // if(dataShared.getters.getDataByUserLogged) {
  //   let user = dataShared.getters.getDataByUserLogged;

  //   user?.purchases.find(el => {
  //     if (eventId == el?.event_id && el?.price == null){
  //       return (acquired.value = true)
  //     } else {
  //       acquired.value = false
  //     }
  //   });
  // }
})

onMounted(() => {
  dataShared.dispatch('activeLoading')

  initFlowbite()
  window.scrollTo(0, 0)

  if (couponId.value) validityCoupon(couponId.value)
  else if (fighter && affiliate) getSponsorship(fighter, affiliate)
  else getItem()

  dataShared.dispatch('desactiveLoading')
})
</script>

<style scoped>
@media (max-width: 768px) {
  .sticky {
    position: relative;
    top: unset;
  }
}
</style>
